import { render, staticRenderFns } from "./QuoteDetails.vue?vue&type=template&id=8d4b5cb6&scoped=true&"
import script from "./QuoteDetails.vue?vue&type=script&lang=js&"
export * from "./QuoteDetails.vue?vue&type=script&lang=js&"
import style0 from "./QuoteDetails.vue?vue&type=style&index=0&id=8d4b5cb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4b5cb6",
  null
  
)

export default component.exports